import "./Home.css";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

import "bootstrap/dist/css/bootstrap.min.css";

function Home() {
  return (
    <div className="hero-container">
      <Container className="py-3">
        {/* Hero Section */}
        <Row className="align-items-center py-5">
          <Col xs={12} md={8} className="text-center text-md-start">
            <h1 className="fs-1 text-white">
              Grüne Wege GmbH - Ihr Partner im Garten- und Landschaftsbau
            </h1>
            <p className="text-break fs-5 text-white mt-4">
              Als Familienbetrieb ist es unsere Leidenschaft, Ihren Hof und
              Garten zu gestalten. Wir bieten Ihnen von der Beratung über Erd-
              und Pflasterarbeiten, der Gestaltung von Grünanlagen mit einer
              vielfältigen Pflanzenauswahl, bis hin zur Pflege Ihres Baum- und
              Grünbestandes, einen umfassenden Service.
            </p>
          </Col>
          <Col
            xs={12}
            md={4}
            className="d-flex justify-content-center mt-4 mt-md-0"
          >
            <Image
              src="http://picsum.photos/350/350"
              roundedCircle
              className="img-fluid shadow-lg"
            />
          </Col>
        </Row>

        {/* Cards Section */}
        <Row className="pt-5 g-4 justify-content-center">
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Card className="shadow-lg bg-dark text-white" style={{ width: "18rem" }}>
              <Card.Img variant="top" src="http://picsum.photos/180/100" />
              <Card.Body>
                <Card.Title>Beratung & Planung</Card.Title>
                <Card.Text>
                  Individuelle Beratung und maßgeschneiderte Lösungen für Ihren
                  Garten.
                </Card.Text>
                <Button as={Link} to="/beratung&planung" variant="outline-light">
                Mehr erfahren
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Card className="shadow-lg bg-dark text-white" style={{ width: "18rem" }}>
              <Card.Img variant="top" src="http://picsum.photos/180/100" />
              <Card.Body>
                <Card.Title>Gartenbau, Erd- und Pflasterarbeiten</Card.Title>
                <Card.Text>
                   Von der Idee zur umsetetzung - wir gestalten Ihren Garten.
                </Card.Text>
                <Button as={Link} to="/galabau" variant="outline-light">
                Mehr erfahren
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Card className="shadow-lg bg-dark text-white" style={{ width: "18rem" }}>
              <Card.Img variant="top" src="http://picsum.photos/180/100" />
              <Card.Body>
                <Card.Title>Pflege & Erhalt</Card.Title>
                <Card.Text>
                  Regelmäßige Pflege für Bäume, Grünanlagen und mehr.
                </Card.Text>
                <Button as={Link} to="/pflege&erhalt" variant="outline-light">
                Mehr erfahren
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;
